import { useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useOrganizationStore } from '@/stores/organization'
import DepartmentTree from '@/components/Organization/DepartmentTree'
import MemberList from '@/components/Organization/MemberList'
import { ChevronLeft } from 'lucide-react'

const OrganizationDetails = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const organizationId = searchParams.get('id') || ''
  const { currentOrganization } = useOrganizationStore()


  const title = useMemo(
    () => currentOrganization?.name || '组织详情',
    [currentOrganization]
  )

  return (
    <div className="h-full flex flex-col bg-transparent">
      {/* 头部 */}
      <div className="flex items-center gap-3 mb-4">
        <button
          type="button"
          className="inline-flex items-center gap-1 text-[#3D1E82] hover:opacity-80"
          onClick={() => navigate(-1)}
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <h1 className="font-medium" style={{ color: '#000000', fontSize: 24 }}>
          {title}
        </h1>
      </div>

      {/* 主体：左右结构 */}
      <div className="flex-1 grid grid-cols-12 gap-4 min-h-0">
        <div className="col-span-4 min-h-0">
          <DepartmentTree teamId={currentOrganization?.id || organizationId} />
        </div>
        <div className="col-span-8 min-h-0">
          <MemberList />
        </div>
      </div>
    </div>
  )
}

export default OrganizationDetails
